export default __webpack_public_path__ + "static/media/scratch-card-image.047d8970.svg";